export enum OrderDeliveryConfirmationEnum {
  signature = 'signature',
  delivery = 'delivery',
  none = 'none',
}
